import { parseJsonAttribute } from '@shared/lib';

// Пропсы СЕО-страницы приходят атрибутами якоря — иначе гидрация сотрёт заголовок.
export function readSeoAnchorProps(anchor: Element | null): Record<string, unknown> {
    return {
        ...parseJsonAttribute(anchor, 'data-seo-props', {}),
        title: anchor?.getAttribute('data-seo-title') ?? '',
        titleTag: anchor?.getAttribute('data-seo-title-tag') ?? 'h1',
        subtitle: anchor?.getAttribute('data-seo-subtitle') ?? '',
        logo: anchor?.getAttribute('data-seo-logo') ?? '',
        tabs: parseJsonAttribute(anchor, 'data-seo-tabs', []),
        vertical: anchor?.getAttribute('data-seo-vertical') || 'tours',
    };
}
